@if (dataSignal().length) {
<owl-carousel-o class="custom-carousel" [options]="carouselOptions">
  @for (slide of dataSignal(); track slide;let i = $index) {
  <ng-template carouselSlide id="i">
    <div class="flex-carousel carousel-background img-box-carousel">
      @if(slide.imgFeature){
      <img
        class="image-carousel"
        [src]="replaceBucket.replaceBucket(slide.imgFeature)"
        [alt]="slide.title"
        [title]="slide.title"
        loading="lazy"
      />
      }
    </div>
    <div class="flex-carousel-col img-box-carousel text-detail-carousel">
      <h4 class="font-size-22 font-weight-bold break-word tire-feature">{{ slide.title }}</h4>
      <p class="font-size-16 font-weight-regular">{{ slide.detail }}</p>
    </div>
  </ng-template>
  }
</owl-carousel-o>
}
